var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-width fill-height",attrs:{"id":"map"}},[_c('the-mobile-map-buttons',{staticClass:"mobile-map-buttons"}),_c('the-mobile-map-legend',{staticClass:"mobile-map-legend"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }